import React, { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { HISTORICAL_PAGE_TYPE, HistoricalPageType } from './constants';
import HistoricalSideNavContainer from './HistoricalSideNavContainer';

// Opt-in allow-list: pages here get the `enrollment-history-container` wrapper; everything else doesn't.
const BOXED_OUTLET_PAGES: ReadonlySet<HistoricalPageType> = new Set([
    HISTORICAL_PAGE_TYPE.BASIC_INFO,
    HISTORICAL_PAGE_TYPE.APPLICATIONS,
    HISTORICAL_PAGE_TYPE.ENROLLMENTS,
]);

// ============================================================================
// Component
// ============================================================================

function HistoricalApplicationsContainer() {
    const location = useLocation();
    const currentPath = location.pathname;

    const currentPage: HistoricalPageType = useMemo(() => {
        if (currentPath.includes('/historical/applications')) {
            return HISTORICAL_PAGE_TYPE.APPLICATIONS;
        }
        if (currentPath.includes('/historical/enrollments')) {
            return HISTORICAL_PAGE_TYPE.ENROLLMENTS;
        }
        if (currentPath.includes('/historical/documents')) {
            return HISTORICAL_PAGE_TYPE.DOCUMENTS;
        }
        if (currentPath.includes('/historical/notices')) {
            return HISTORICAL_PAGE_TYPE.NOTICES;
        }
        return HISTORICAL_PAGE_TYPE.BASIC_INFO;
    }, [currentPath]);

    const contentClassName = BOXED_OUTLET_PAGES.has(currentPage)
        ? 'desktop:grid-col-9 enrollment-history-container'
        : 'desktop:grid-col-9';

    return (
        <HistoricalSideNavContainer page={currentPage}>
            <div className={contentClassName} id="historical-applications-content">
                <Outlet />
            </div>
        </HistoricalSideNavContainer>
    );
}

export default HistoricalApplicationsContainer;
